
import api from "metabase/lib/api";


export let isJsonEnabled;
export let isXlsxEnabled;


export const initExportFlags = () => {
  api.GET('/api/public/hack/is-export-enabled',
    ({xlsx, json}) =>
    {
      isXlsxEnabled = xlsx;
      isJsonEnabled = json;
    }).call();
};



// WEBPACK FOOTER //
// ./export-hack.js